import { render, staticRenderFns } from "./NPSList.vue?vue&type=template&id=16bef7f9"
import script from "./NPSList.vue?vue&type=script&lang=js"
export * from "./NPSList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports